/**
 * Appearance Settings Page
 *
 * Allows users to customize the visual appearance of the application.
 */

import { Typography, Space } from 'antd';
import ThemeSwitcher from '@components/settings/ThemeSwitcher';
import FontSwitcher from '@components/settings/FontSwitcher';
import TerminologySettings from '@components/settings/TerminologySettings';

const { Title } = Typography;

export default function AppearanceSettingsPage() {
  return (
    <div style={{ padding: '24px' }}>
      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        <div>
          <Title level={3}>Appearance Settings</Title>
        </div>

        <div style={{ maxWidth: 1000 }}>
          <ThemeSwitcher />

          <div style={{ marginTop: 24 }}>
            <FontSwitcher />
          </div>

          <div style={{ marginTop: 24 }}>
            <TerminologySettings />
          </div>
        </div>
      </Space>
    </div>
  );
}
